import React from 'react';
import { translate, SelectInput } from 'react-admin';

const DayOfWeekSelectInput = ({translate, source, ...props}) => {
  const daysOfWeek = [
    { id: 'MONDAY',     name: translate('daysOfWeek.MONDAY') },
    { id: 'TUESDAY',    name: translate('daysOfWeek.TUESDAY') },
    { id: 'WEDNESDAY',  name: translate('daysOfWeek.WEDNESDAY') },
    { id: 'THURSDAY',   name: translate('daysOfWeek.THURSDAY') },
    { id: 'FRIDAY',     name: translate('daysOfWeek.FRIDAY') },
    { id: 'SATURDAY',   name: translate('daysOfWeek.SATURDAY') },
    { id: 'SUNDAY',     name: translate('daysOfWeek.SUNDAY') },
  ]
  
  return (
    <SelectInput source={source} choices={daysOfWeek} />
  )
}

export default translate(DayOfWeekSelectInput)